const ErrorMessages = {
	DEFAULT: 'Something went wrong. Please try again.',
	INVALID_CREDENTIALS: 'The username and/or password you entered was incorrect.',
	EXPIRED_SESSION: 'Your session has expired. Please log in again.',
	400: 'Bad request. The request could not be understood by the server.',
    401: 'Unauthorized. The request requires user authentication.',
    403: 'Unauthorized. Not authorized to perform requested operation.',
	404: 'Not found. The server has not found anything matching the requested URI.',
    413: 'Request too large. The server is refusing to process a request because the request entity is larger than the server is willing or able to process.',
    429: 'Too many requests. You have exceeded your rate limit. Please try again later.',
	500: 'Internal server error. The server encountered an unexpected condition which prevented it from fulfilling the request.',
	503: 'Service unavailable. The server is currently unable to handle the request due to a temporary overloading or maintenance of the server.',
	504: 'Gateway timeout. The server, while acting as a gateway or proxy, did not receive a timely response from the upstream server.'
};

export default ErrorMessages;
